import { memo, useEffect, useState, } from "react";
import { Button, Checkbox, Input, Popconfirm, Space, Table, TableProps, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { mdlTablePagination } from "../../../models/ui-models/TablePagination";
import { mdlHotelRoom } from "../../../models/domain/HotelRoom";
import { mdlHotelRoomAndType } from "../../../models/domain/HotelRoomAndType";
import _ from "lodash";

export type RoomTableForNewAddProps = {
    fnActiveItemSelect?: Function;
    activeItem?: mdlHotelRoomAndType;
    fnSelectAll?: any;
    onTableItemSelect?: any;
    tableItems?: mdlHotelRoom[];
    onDelete?: Function;
    onEdit?: Function;
    pagination: mdlTablePagination;
    onTableParamsChange?: Function;
    selectedRoomList?: string[];
    selectedHotel?:string;
    selectedRoomListForAddNew?:string[] ;
    selectedRoomTypeListForAddNew?:string[] ;
    roomCapacityList?:mdlHotelRoomAndType[];
    fnPrepareRoomCapacityList?: Function;
    autoFocus?:string;
    fnSetAutoFocus?: Function;
}

export const RoomTableForNewAdd = memo(function RoomTableForNewAdd(props: RoomTableForNewAddProps) {
    const { t } = useTranslation();
    const [roomCapacityList, setRoomCapacityList] = useState<mdlHotelRoomAndType[]>([]);

    useEffect(() => {
        if (props.roomCapacityList && roomCapacityList.length == 0){
            if(props.activeItem){
                const _roomCapacityList = props.roomCapacityList.filter(x => x.id == props.activeItem?.hotelRoomId).map( (x) => {
                    x.maxChilds = props.activeItem?.maxChilds;
                    return x;
                })
                setRoomCapacityList(_roomCapacityList)
                props.fnActiveItemSelect && props.fnActiveItemSelect(props.activeItem.hotelRoomId)
        }else{
                setRoomCapacityList(props.roomCapacityList)
            }
        }
    }, [props]);
    
    const checkList = (id:string) => {
        return (props.selectedRoomListForAddNew?.find(x => x==id) != undefined) as boolean;
    }
    const onChange = (e:any) => {
        const id = e.target.getAttribute('data-id');
        const name = e.target.getAttribute('name');
        const data = e.target.value;
        let _roomCapacityList = _.cloneDeep(props.roomCapacityList); 
        _roomCapacityList?.map(function(x:any){
            if(x.roomId == id){
                x[name] = data;
            }
        });
        props.fnPrepareRoomCapacityList?.(_roomCapacityList);
        props.fnSetAutoFocus && props.fnSetAutoFocus(name)
    }
    const getTotal = (id:string, maxAdult:number) => {
        if(!id)
            return 0;
        const maxChild = props.roomCapacityList?.find(x => x.id == id)?.maxChilds ?? 0;
        if(!maxChild)
            return 0;
        if(!maxAdult)
            return maxChild;
        return parseInt(maxAdult.toString()) + parseInt(maxChild.toString());
    }
    const columns: TableProps<mdlHotelRoomAndType>['columns'] = [
        {
            title: <>
                <Checkbox onClick={props.fnSelectAll} checked={props.selectedRoomListForAddNew?.length == props.tableItems?.length}></Checkbox>
            </>,
            key: 'check',
            width:30,
            render: (_, record) => (
                <Space size="middle">
                    <Checkbox onChange={props.onTableItemSelect} checked={checkList(record.roomId ?? "")} value={record.roomId ?? ""}></Checkbox>
                </Space>
            ),
        },
        {
            title: t("definitions.hotels.name"),
            dataIndex: 'roomName',
            key:"roomName"
        },
        {
            title: t("definitions.hotels.adult"),
            dataIndex: 'adult',
            render: (_, record) => (
                <Space size="middle">
                    <Input size="small" name="adults" autoFocus={props.autoFocus == "adults"} type="text" value={record.adultNumber} data-id={record.roomId ?? ""} onChange={onChange} placeholder="adult" disabled={true}></Input>
                </Space>
            ),
        },
        {
            title: t("definitions.hotels.maxChild"),
            dataIndex: 'maxChild',
            render: (_, record) => (
                <Space size="middle">
                    <Input size="small" name="maxChilds" autoFocus={props.autoFocus == "maxChilds"} type="text" defaultValue={record.maxChilds} data-id={record.roomId ?? ""} onChange={onChange} placeholder="maxChild" disabled={!checkList(record.roomId ?? "")}></Input>
                </Space>
            ),
        },
        {
            title: t("definitions.hotels.maxPax"),
            dataIndex: 'maxPax',
            render: (_, record) => (
                <Space size="middle">
                    <Input size="small" name="maxPax" autoFocus={props.autoFocus == "maxPax"} type="text" value={getTotal(record.id,record.maxAdults ?? (record.adultNumber ?? 0))} data-id={record.roomId ?? ""} onChange={onChange} placeholder="maxPax" disabled={true}></Input>
                </Space>
            ),
        }
    ];

    const handleTableChange: TableProps<mdlHotelRoomAndType>['onChange'] = (pagination, filters, sorter) => {
        props.onTableParamsChange && props.onTableParamsChange(pagination, filters);
    }

    return (
        <>
        <div className="row">
            {
                props.tableItems
                &&
                <div className="col-sm-12">
                    <Table<mdlHotelRoom>
                        onChange={handleTableChange}
                        size="middle"
                        columns={columns}
                        pagination={props.pagination}
                        scroll={{ x: 'max-content' }}
                        dataSource={roomCapacityList.map((data: mdlHotelRoomAndType, index: number) => ({ ...data, key: index }))}
                    />
                </div>
            }
        </div>
        </>
    )
})